/**
 * Mobile floating form button (templates/_components/_mobile-form-button.twig).
 *
 * Shown on article pages with a sidebar petition or publication and on petition pages, below the
 * lg breakpoint. The bar hides once the top of the form enters the viewport and stays hidden
 * below it, and comes back when the visitor scrolls up above the form again.
 *
 * A scroll check rather than an IntersectionObserver: a jump straight past the form (End key,
 * a fast fling) never makes it intersect, so the observer would leave the bar showing.
 */
export function initMobileFormButton() {
  const bar = document.querySelector('[data-mobile-form-button]');
  const link = bar?.querySelector('[data-mobile-form-button-link]');
  const target = link ? document.getElementById(link.hash.slice(1)) : null;

  if (!bar || !target) {
    bar?.remove();
    return;
  }

  let ticking = false;

  const update = () => {
    ticking = false;
    const reached = target.getBoundingClientRect().top < window.innerHeight;
    bar.classList.toggle('is-hidden', reached);

    // Lets fixed widgets at the bottom (the OneSignal bell) sit above the bar; 0 on desktop
    const offset = reached ? 0 : bar.offsetHeight;
    document.documentElement.style.setProperty('--mobile-form-button-offset', `${offset}px`);
  };

  const requestUpdate = () => {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  };

  window.addEventListener('scroll', requestUpdate, {passive: true});
  window.addEventListener('resize', requestUpdate, {passive: true});
  update();

  link.addEventListener('click', (e) => {
    e.preventDefault();

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({behavior: reduceMotion ? 'auto' : 'smooth', block: 'start'});

    // Move keyboard and screen reader focus to the form without a second jump
    if (!target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
    }
    target.focus({preventScroll: true});
  });
}
